document.addEventListener('DOMContentLoaded', function () {
  const bar =
    document.querySelector('[data-sticky-pdp-bar]') ||
    document.querySelector('[data-sticky-pdp]');
  if (!bar) return;

  const variantsJsonEl = document.querySelector('[data-sticky-pdp-variants]');
  if (!variantsJsonEl) {
    console.warn('Sticky PDP: variants JSON element not found.');
    return;
  }

  let variants = [];
  try {
    variants = JSON.parse(variantsJsonEl.textContent);
  } catch (error) {
    console.warn('Sticky PDP: variants JSON could not be parsed.', error);
    return;
  }

  const imageEl = bar.querySelector('[data-sticky-pdp-image]');
  const availabilityEl = bar.querySelector('[data-sticky-pdp-availability]');
  const variantEl = bar.querySelector('[data-sticky-pdp-variant]');
  const priceEl = bar.querySelector('[data-sticky-pdp-price]');
  const oldPriceEl = bar.querySelector('[data-sticky-pdp-old-price]');
  const discountEl = bar.querySelector('[data-sticky-pdp-discount]');
  const ctaEl = bar.querySelector('[data-sticky-pdp-cta]');
  const ctaTextEl = bar.querySelector('[data-sticky-pdp-cta-text]');
  const planEl =
    bar.querySelector('[data-sticky-pdp-plan]') ||
    bar.querySelector('[data-sticky-pdp-purchase-type]');
  const purchaseNoteEl = bar.querySelector('[data-sticky-pdp-purchase-note]');

  const productFormEl = document.querySelector('product-form form[action*="/cart/add"]');
  const addToCartBtn = document.querySelector('[data-js-product-add-to-cart]');
  const variantIdInput = productFormEl ? productFormEl.querySelector('input[name="id"]') : null;

  if (!productFormEl || !variantIdInput) {
    console.warn('Sticky PDP: product form or variant id input not found.');
    return;
  }

  const WIDGET_ROOT_SELECTORS = [
    '.appstle_sub_widget',
    '.appstle_subscription_wrapper',
    '.appstle_subscription_widget',
    '.appstleSellingPlanWrapper',
    '.shopify_subscriptions_app_block',
    '.loop-subscriptions'
  ];

  const PRICE_SELECTORS = [
    '.appstle_subscription_amount',
    '.appstle_subscription_price',
    '.appstleSellingPlanPrice',
    '.appstlePrice',
    '.appstle-option-price',
    '.appstle-selling-plan-price',
    '[class*="price"]'
  ];

  const CART_DRAWER_ROOT_SELECTORS = [
    'cart-drawer',
    '#CartDrawer',
    '.cart-drawer',
    '.drawer--cart',
    '.js-cart-drawer',
    '[data-cart-drawer]',
    '[data-drawer="cart"]'
  ];

  const CART_DRAWER_OPEN_CLASSNAMES = [
    'is-open',
    'open',
    'active',
    'is-active',
    'drawer--open',
    'cart-drawer--open',
    'visible',
    'is-visible'
  ];

  const CART_OPEN_BODY_CLASSNAMES = [
    'cart-open',
    'cart-drawer-open',
    'drawer-open',
    'js-drawer-open'
  ];

  function formatMoney(cents) {
    if (typeof cents !== 'number' || Number.isNaN(cents)) return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const format =
        (window.theme && window.theme.moneyFormat) ||
        window.Shopify.money_format ||
        '${{amount}}';

      return window.Shopify.formatMoney(cents, format);
    }

    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function parseMoneyString(value) {
    if (!value) return null;

    const cleaned = String(value)
      .replace(/\s/g, '')
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^0-9.]/g, '');

    const number = parseFloat(cleaned);
    if (Number.isNaN(number)) return null;

    return Math.round(number * 100);
  }

  function getTextContentSafe(element) {
    return element ? element.textContent.trim() : '';
  }

  function getVariantById(id) {
    return (
      variants.find(function (variant) {
        return String(variant.id) === String(id);
      }) || null
    );
  }

  function getVariantImage(variant) {
    if (!variant) return null;

    if (variant.featured_image) {
      if (variant.featured_image.src) return variant.featured_image.src;
      if (variant.featured_image.url) return variant.featured_image.url;
    }

    if (variant.featured_media && variant.featured_media.preview_image) {
      if (variant.featured_media.preview_image.src) return variant.featured_media.preview_image.src;
      if (variant.featured_media.preview_image.url) return variant.featured_media.preview_image.url;
    }

    return null;
  }

  function getCurrentVariantId() {
    return variantIdInput ? variantIdInput.value : null;
  }

  function getWidgetRoots() {
    return Array.from(document.querySelectorAll(WIDGET_ROOT_SELECTORS.join(', ')));
  }

  function getAppstleWidget() {
    return (
      document.querySelector('.appstle_sub_widget') ||
      document.querySelector('.appstle_subscription_widget') ||
      document.querySelector('.appstle_subscription_wrapper')
    );
  }

  function getCurrentSellingPlanValue() {
    const widget = getAppstleWidget();

    const checkedSellingPlanRadio = document.querySelector('input[name="selling_plan"]:checked');
    if (checkedSellingPlanRadio) {
      const radioValue = String(checkedSellingPlanRadio.value || '').trim();

      if (radioValue === '') {
        return '';
      }

      const appstleSelect = widget ? widget.querySelector('.appstle_select') : null;
      if (appstleSelect && appstleSelect.value) {
        return String(appstleSelect.value).trim();
      }

      return radioValue;
    }

    const appstleSelectedPlanInput = widget
      ? widget.querySelector('.appstle-selectedSellingPlan')
      : null;

    if (appstleSelectedPlanInput && appstleSelectedPlanInput.value) {
      return String(appstleSelectedPlanInput.value).trim();
    }

    const appstleSelect = widget ? widget.querySelector('.appstle_select') : null;
    if (appstleSelect && appstleSelect.value) {
      return String(appstleSelect.value).trim();
    }

    if (widget && widget.dataset.selectedSellingPlan) {
      return String(widget.dataset.selectedSellingPlan).trim();
    }

    const sellingPlanSelect = productFormEl.querySelector('select[name="selling_plan"]');
    const sellingPlanInput = productFormEl.querySelector('input[name="selling_plan"]');

    if (sellingPlanSelect && sellingPlanSelect.value) {
      return String(sellingPlanSelect.value).trim();
    }

    if (sellingPlanInput && sellingPlanInput.value) {
      return String(sellingPlanInput.value).trim();
    }

    return '';
  }

  function getCurrentPurchaseType() {
    const checkedSellingPlanRadio = document.querySelector('input[name="selling_plan"]:checked');

    if (checkedSellingPlanRadio) {
      return String(checkedSellingPlanRadio.value || '').trim() === ''
        ? 'one-time'
        : 'subscription';
    }

    return getCurrentSellingPlanValue() !== '' ? 'subscription' : 'one-time';
  }

  function findPriceInElement(scope) {
    if (!scope) return null;

    for (const selector of PRICE_SELECTORS) {
      const priceNode = scope.querySelector(selector);
      const parsed = parseMoneyString(getTextContentSafe(priceNode));
      if (parsed !== null) return parsed;
    }

    const text = getTextContentSafe(scope);
    const matches = text.match(/\d{1,3}(?:\.\d{3})*,\d{2}\s*€/g);
    if (matches && matches.length) {
      return parseMoneyString(matches[0]);
    }

    return null;
  }

  function getSelectedSubscriptionOptionElement() {
    const checked = document.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');

    if (!checked || String(checked.value || '').trim() === '') return null;

    return checked.closest('.appstle_subscription_wrapper_option');
  }

  function getOneTimeOptionElement() {
    const checked = document.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');

    if (checked && String(checked.value || '').trim() === '') {
      return checked.closest('.appstle_subscription_wrapper_option');
    }

    const candidates = Array.from(
      document.querySelectorAll('.appstle_sub_widget .appstle_subscription_wrapper_option')
    );

    return (
      candidates.find(function (element) {
        const text = (element.textContent || '').toLowerCase();
        return text.includes('einmal kaufen') || text.includes('one time');
      }) || null
    );
  }

  function getSubscriptionPriceFromWidget() {
    const selectedOption = getSelectedSubscriptionOptionElement();
    return findPriceInElement(selectedOption);
  }

  function getOneTimePriceFromWidget() {
    const oneTimeOption = getOneTimeOptionElement();
    return findPriceInElement(oneTimeOption);
  }

  function updatePurchaseInfo() {
    const purchaseType = getCurrentPurchaseType();

    if (planEl) {
      planEl.classList.remove('is-subscription', 'is-onetime');
      planEl.style.display = '';

      if (purchaseType === 'subscription') {
        planEl.textContent = '🐾 Spar-Abo aktiv · 5 % günstiger';
        planEl.classList.add('is-subscription');
      } else {
        planEl.textContent = 'Einmalkauf';
        planEl.classList.add('is-onetime');
      }
    }

    if (purchaseNoteEl) {
      purchaseNoteEl.textContent =
        purchaseType === 'subscription'
          ? 'Im Abo dauerhaft 5 % sparen'
          : 'Im Spar-Abo dauerhaft 5 % sparen';
    }
  }

  function updateStickyUI(variant) {
    updatePurchaseInfo();
    if (!variant) return;

    const purchaseType = getCurrentPurchaseType();

    let activePrice = variant.price;
    let referenceOldPrice =
      variant.compare_at_price && variant.compare_at_price > variant.price
        ? variant.compare_at_price
        : null;

    if (purchaseType === 'subscription') {
      const subscriptionPrice = getSubscriptionPriceFromWidget();
      const oneTimePrice = getOneTimePriceFromWidget();

      if (subscriptionPrice !== null) {
        activePrice = subscriptionPrice;
      }

      if (oneTimePrice !== null && oneTimePrice > activePrice) {
        referenceOldPrice = oneTimePrice;
      }
    } else {
      const oneTimePrice = getOneTimePriceFromWidget();
      if (oneTimePrice !== null) {
        activePrice = oneTimePrice;
      }
    }

    if (priceEl) {
      priceEl.textContent = formatMoney(activePrice);
    }

    if (oldPriceEl && discountEl) {
      if (referenceOldPrice && referenceOldPrice > activePrice) {
        oldPriceEl.style.display = '';
        discountEl.style.display = '';
        oldPriceEl.textContent = formatMoney(referenceOldPrice);

        const discount = Math.round(
          ((referenceOldPrice - activePrice) * 100) / referenceOldPrice
        );
        discountEl.textContent = `-${discount}%`;
      } else {
        oldPriceEl.style.display = 'none';
        discountEl.style.display = 'none';
        oldPriceEl.textContent = '';
        discountEl.textContent = '';
      }
    }

    if (availabilityEl) {
      availabilityEl.textContent = variant.available
        ? 'Zustellung in 1–3 Tagen'
        : 'Ausverkauft';

      availabilityEl.classList.toggle('is-available', !!variant.available);
      availabilityEl.classList.toggle('is-unavailable', !variant.available);
    }

    if (variantEl) {
      if (variant.title && variant.title !== 'Default Title') {
        variantEl.style.display = '';
        variantEl.textContent = `· ${variant.title}`;
      } else {
        variantEl.style.display = 'none';
        variantEl.textContent = '';
      }
    }

    // Grundpreis (PAngV) der gewählten Variante
    const unitEl = bar.querySelector('[data-sticky-pdp-unit]');
    if (unitEl) {
      try {
        const units = JSON.parse((document.querySelector('[data-sticky-pdp-units]') || {}).textContent || '{}');
        if (units[String(variant.id)] !== undefined) unitEl.innerHTML = units[String(variant.id)];
      } catch (e) {}
    }

    if (imageEl) {
      const featuredImage = getVariantImage(variant);
      if (featuredImage) {
        imageEl.src = featuredImage;
      }
    }

    // Ausverkauft + Notim vorhanden: Leisten-Button öffnet die Benachrichtigung statt deaktiviert zu sein
    const canNotify = !variant.available && !!document.querySelector('#nm-btn-container .nm-btn');

    if (ctaEl) {
      ctaEl.disabled = !variant.available && !canNotify;
      ctaEl.classList.toggle('is-disabled', !variant.available && !canNotify);
      ctaEl.classList.toggle('is-notify', canNotify);
    }

    if (ctaTextEl) {
      // Vorbestellung (Map aus main-product, gp-preorder.js): gleicher Text wie der Kaufknopf
      let availableText = 'Ab ins Warenkörbchen';
      try {
        const mapEl = document.querySelector('[data-gp-preorder-map]');
        const entry = mapEl && JSON.parse(mapEl.textContent).variants[String(variant.id)];
        if (entry === true || (entry && entry.pre)) availableText = 'Jetzt vorbestellen';
      } catch (e) {}
      ctaTextEl.textContent = variant.available
        ? availableText
        : (canNotify ? 'Benachrichtigen' : 'Nicht verfügbar');
    }
  }

  function syncFromForm() {
    const currentId = getCurrentVariantId();
    if (!currentId) return;

    const variant = getVariantById(currentId);
    if (!variant) return;

    updateStickyUI(variant);
  }

  function getCartDrawerElements() {
    return Array.from(document.querySelectorAll(CART_DRAWER_ROOT_SELECTORS.join(', ')));
  }

  function isCartDrawerOpen() {
    const drawers = getCartDrawerElements();

    const bodyHasOpenClass = CART_OPEN_BODY_CLASSNAMES.some(function (className) {
      return document.body.classList.contains(className);
    });

    if (bodyHasOpenClass) return true;

    return drawers.some(function (drawer) {
      if (!drawer) return false;

      const hasOpenClass = CART_DRAWER_OPEN_CLASSNAMES.some(function (className) {
        return drawer.classList.contains(className);
      });

      if (hasOpenClass) return true;

      const ariaHidden = drawer.getAttribute('aria-hidden');
      if (ariaHidden === 'false') return true;

      if (drawer.hasAttribute('open')) return true;

      const hidden = drawer.hasAttribute('hidden');
      if (hidden) return false;

      const style = window.getComputedStyle(drawer);
      const isVisible =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.opacity !== '0';

      return isVisible && drawer.offsetWidth > 0 && drawer.offsetHeight > 0;
    });
  }

  function updateBarCartState() {
    const cartOpen = isCartDrawerOpen();
    bar.classList.toggle('is-hidden-by-cart', cartOpen);
    bar.setAttribute('data-cart-open', cartOpen ? 'true' : 'false');
    document.body.classList.toggle('sticky-pdp-hidden-by-cart', cartOpen);
  }

  let lastScrollY = window.scrollY;
  let ticking = false;

  // Leiste ausblenden, sobald der Footer ins Bild kommt (sonst überdeckt sie das Seitenende)
  const footerEl = document.querySelector('.shopify-section-group-footer-group, [id*="__footer"], footer');
  if (footerEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-at-footer', entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(footerEl);
  }

  function handleStickyVisibility() {
    const currentScrollY = window.scrollY;
    const threshold = 500;

    updateBarCartState();

    if (isCartDrawerOpen()) {
      bar.classList.remove('is-visible', 'is-hidden-by-scroll');
      bar.setAttribute('aria-hidden', 'true');
      lastScrollY = currentScrollY;
      return;
    }

    if (currentScrollY < threshold) {
      bar.classList.remove('is-visible', 'is-hidden-by-scroll');
      bar.setAttribute('aria-hidden', 'true');
      lastScrollY = currentScrollY;
      return;
    }

    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');

    if (currentScrollY > lastScrollY + 8) {
      bar.classList.add('is-hidden-by-scroll');
    } else if (currentScrollY < lastScrollY - 8) {
      bar.classList.remove('is-hidden-by-scroll');
    }

    lastScrollY = currentScrollY;
  }

  function scheduleSync(delay) {
    window.setTimeout(function () {
      syncFromForm();
      updateBarCartState();
      handleStickyVisibility();
    }, delay);
  }

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;

      window.requestAnimationFrame(function () {
        handleStickyVisibility();
        ticking = false;
      });

      ticking = true;
    },
    { passive: true }
  );

  window.addEventListener('resize', function () {
    updateBarCartState();
    handleStickyVisibility();
  });

  const hiddenInputObserver = new MutationObserver(function () {
    syncFromForm();
  });

  hiddenInputObserver.observe(variantIdInput, {
    attributes: true,
    attributeFilter: ['value']
  });

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('.product-variant-value') ||
      event.target.matches('input[name="id"]') ||
      event.target.matches('select[name="id"]') ||
      event.target.matches('input[name="selling_plan"]') ||
      event.target.matches('select[name="selling_plan"]') ||
      event.target.matches('.appstle_select') ||
      event.target.matches('.appstle-selectedSellingPlan') ||
      event.target.closest('product-variants') ||
      event.target.closest('product-form') ||
      event.target.closest('.appstle_sub_widget') ||
      event.target.closest('.appstle_subscription_widget') ||
      event.target.closest('.appstleSellingPlanWrapper') ||
      event.target.closest('.appstle_subscription_wrapper') ||
      event.target.closest('.shopify_subscriptions_app_block') ||
      event.target.closest('.loop-subscriptions')
    ) {
      scheduleSync(50);
      scheduleSync(150);
      scheduleSync(300);
    }
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('[name="selling_plan"]') ||
      event.target.closest('[data-selling-plan]') ||
      event.target.closest('.appstle_sub_widget') ||
      event.target.closest('.loop-subscriptions') ||
      event.target.closest('.shopify_subscriptions_app_block') ||
      event.target.closest('.appstle_subscription_widget') ||
      event.target.closest('.appstleSellingPlanWrapper') ||
      event.target.closest('.appstle_subscription_wrapper')
    ) {
      scheduleSync(50);
      scheduleSync(150);
      scheduleSync(300);
    }

    if (
      event.target.closest('[href="/cart"]') ||
      event.target.closest('[data-cart-toggle]') ||
      event.target.closest('[data-open-cart]') ||
      event.target.closest('.cart-toggle') ||
      event.target.closest('.header__icon--cart')
    ) {
      scheduleSync(50);
      scheduleSync(150);
      scheduleSync(300);
    }
  });

  const widgetRoots = getWidgetRoots();
  if (widgetRoots.length) {
    const widgetObserver = new MutationObserver(function () {
      scheduleSync(50);
      scheduleSync(150);
      scheduleSync(300);
    });

    widgetRoots.forEach(function (root) {
      widgetObserver.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });

      if (root.classList.contains('appstle_sub_widget')) {
        widgetObserver.observe(root, {
          attributes: true,
          attributeFilter: ['data-selected-selling-plan']
        });
      }
    });
  }

  const cartDrawerElements = getCartDrawerElements();
  if (cartDrawerElements.length) {
    const cartDrawerObserver = new MutationObserver(function () {
      updateBarCartState();
      handleStickyVisibility();
    });

    cartDrawerElements.forEach(function (drawer) {
      cartDrawerObserver.observe(drawer, {
        childList: true,
        subtree: false,
        attributes: true,
        attributeFilter: ['class', 'open', 'aria-hidden', 'style', 'hidden']
      });
    });
  }

  const bodyObserver = new MutationObserver(function () {
    updateBarCartState();
    handleStickyVisibility();
  });

  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  document.addEventListener('cart:open', function () {
    updateBarCartState();
    handleStickyVisibility();
  });

  document.addEventListener('cart:close', function () {
    updateBarCartState();
    handleStickyVisibility();
  });

  if (ctaEl) {
    ctaEl.addEventListener('click', function () {
      const currentId = getCurrentVariantId();
      const variant = getVariantById(currentId);

      if (variant && !variant.available) {
        if (typeof window.gpOpenRestockNotify === 'function') window.gpOpenRestockNotify();
        return;
      }
      if (!variant) return;

      if (
        addToCartBtn &&
        !addToCartBtn.disabled &&
        !addToCartBtn.classList.contains('disabled')
      ) {
        addToCartBtn.click();
        scheduleSync(150);
        scheduleSync(350);
        return;
      }

      if (typeof productFormEl.requestSubmit === 'function') {
        productFormEl.requestSubmit();
      } else {
        productFormEl.submit();
      }

      scheduleSync(150);
      scheduleSync(350);
    });
  }

  syncFromForm();
  updateBarCartState();
  handleStickyVisibility();

  scheduleSync(250);
  // Notim (Benachrichtigung bei Ausverkauf) lädt asynchron – Button-Text danach erneut setzen
  scheduleSync(2500);
  scheduleSync(8000);
  scheduleSync(600);
  scheduleSync(1200);
});

(function () {
  var storageKey = 'gpStickyPdpDismissed';

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function initStickyDismiss() {
    var bar =
      document.querySelector('[data-sticky-pdp-bar]') ||
      document.querySelector('[data-sticky-pdp]');
    if (!bar) return;

    var closeBtn = bar.querySelector('[data-sticky-pdp-close]');
    if (!closeBtn) return;

    if (isMobile() && sessionStorage.getItem(storageKey) === 'true') {
      bar.classList.add('is-dismissed');
    }

    closeBtn.addEventListener('click', function () {
      bar.classList.add('is-dismissed');
      if (isMobile()) {
        sessionStorage.setItem(storageKey, 'true');
      }
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        bar.classList.remove('is-dismissed');
      } else if (sessionStorage.getItem(storageKey) === 'true') {
        bar.classList.add('is-dismissed');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyDismiss);
  } else {
    initStickyDismiss();
  }
})();